import Fuse from 'fuse.js';
import template from './dashboardByGroup.component.html';

/**
 * @constant
 * @type {object}
 * {@link https://fusejs.io}
 */
const fuseOptions = {
  // Continue search even if one result is perfect match
  findAllMatches: true,
  // Search individual words and the full string, computing the final score as a function of both
  tokenize: true,
  // Results will only include records that match all tokens
  matchAllTokens: true,
  // Whether to sort the result list, by score
  shouldSort: true,
  maxPatternLength: 24, // UUID
  // List of properties that will be searched
  keys: [
    'name',
    'id',
  ],
  // At what point does the match algorithm give up 0-1 where 0 is === and 1 is anything
  threshold: 0.5,
};


/* @ngInject */
function DashboardByGroupController($scope, GroupService, DashboardInfoService, appConfig) {
  const vm = this;

  vm.boards = [];
  vm.dashboardsByGroups = [];
  vm.groupList = [];
  /** Whether there is current search and no results from it */
  vm.noResults = false;
  vm.settings = appConfig.user.settings;

  vm.find = find;

  vm.$onChanges = ({ search }) => {
    if (!search || search.isFirstChange()) {
      return;
    }

    // Reset noResults
    if (search.currentValue === '') {
      vm.noResults = false;
    }
  };

  $scope.$watch(
    () => DashboardInfoService.dashboards,
    (boards) => {
      vm.boards = boards;
      vm.boardSearch = new Fuse(boards, fuseOptions);

      if (_.isEmpty(boards)) {
        return;
      }
      getTree().then(filterTree);
    },
    true
  );

  function getTree() {
    return GroupService.getGroupTree()
      .then(({ data }) => {
        if (vm.groupList[0]) {
          // Preserve expansion state in groups when updates to model occur
          _.mergeWith(vm.groupList[0], data[0], (__, srcValue, key) => {
            // This customizer is here to handle when dashboards are deleted, but cache still has board in local copy
            if (key === 'dashboards') {
              return srcValue; // Merge everything normally except dashboards.  Always overwrite with incoming src
            }
            // returning undefined makes _.mergeWith customizer function act like a normal _.merge
          });
        } else {
          vm.groupList = data;
        }
      });
  }

  function filterTree() {
    const { dashboards } = DashboardInfoService;
    const { groupList } = vm;
    if (!groupList || !dashboards) {
      return;
    }
    removeDupeDash(groupList[0], _.keyBy(dashboards, 'id'));
    vm.dashboardsByGroups = groupList;
  }

  /**
   * Adds the dashboard name based on id.
   * Removes a duplicate dashboards from a group if it exist in its children.
   *
   * @param {object} group Tree of group objects
   * @param {Array<object>} dashboards
   * @returns {Array<object>} group Tree with unique dashboard names
   */
  function removeDupeDash(group, dashboards) {
    _.each(group.dashboards, (db) => {
      db.name = dashboards[db.id].name;
    });
    if (_.isEmpty(group.subGroups)) {
      return group.dashboards;
    }
    let childrenDashboards = [];
    _.forEach(group.subGroups, (sg) => {
      childrenDashboards = [...childrenDashboards, ...removeDupeDash(sg, dashboards)];
    });
    _.pullAllBy(group.dashboards, childrenDashboards, 'id');
    return _.unionBy(group.dashboards, childrenDashboards, 'id');
  }

  /**
   * Simple wrapper for vm.boardSearch.search (Fuse instance)
   *
   * @param {string} term
   * @returns {Array<object>}
   */
  function find(term) {
    const results = vm.boardSearch.search(term);
    vm.noResults = _.isEmpty(results);
    return results;
  }
}

export default {
  name: 'dashboardByGroup',
  template,
  controller: DashboardByGroupController,
  bindings: {
    search: '<?'
  }
};
